export default "__VITE_ASSET__424766f4__"